import React, { useState } from 'react';
import { isIOSDevice, isAndroidDevice } from '../../utils/mobileDetect';
import styles from './Mobile.module.css';

// Update this when the iOS app is published to the App Store
const IOS_APP_STORE_URL = 'https://apps.apple.com/app/rafiki-ai/id6745103350';

const AppStoreBanner: React.FC = () => {
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem('rafiki_banner_dismissed') === 'true'
    );

    if (dismissed) return null;

    const handleDismiss = () => {
        sessionStorage.setItem('rafiki_banner_dismissed', 'true');
        setDismissed(true);
    };

    const isIOS = isIOSDevice();
    const isAndroid = isAndroidDevice();

    return (
        <div className={styles.banner}>
            <div className={styles.bannerText}>
                {isIOS && IOS_APP_STORE_URL ? (
                    <>
                        Get the full Rafiki experience on our app.
                        <br />
                        <a
                            href={IOS_APP_STORE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.bannerLink}
                        >
                            Open in App Store
                        </a>
                    </>
                ) : isIOS ? (
                    <>Full Rafiki app coming soon to the App Store. Use desktop for the complete experience.</>
                ) : isAndroid ? (
                    <>For the full experience, visit <strong>app.getrafiki.ai</strong> on your desktop.</>
                ) : (
                    <>For the full experience, visit <strong>app.getrafiki.ai</strong> on your desktop.</>
                )}
            </div>
            <button className={styles.bannerDismiss} onClick={handleDismiss}>
                &times;
            </button>
        </div>
    );
};

export default AppStoreBanner;
